import { SvgIcon, useTheme } from "@mui/material";

const DateTimeIcon = ({ color, fontSize, bgColor }) => {

    const theme = useTheme();

    return (
        <SvgIcon sx={{ fontSize: fontSize || 32, mt: .3, mx: 1 }}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_534_732)">
                    <path d="M26 4H22V2H20V4H12V2H10V4H6C5.46977 4.00066 4.96145 4.21159 4.58652 4.58652C4.21159 4.96145 4.00066 5.46977 4 6V26C4.00066 26.5302 4.21159 27.0386 4.58652 27.4135C4.96145 27.7884 5.46977 27.9993 6 28H26C26.5302 27.9993 27.0386 27.7884 27.4135 27.4135C27.7884 27.0386 27.9993 26.5302 28 26V6C27.9993 5.46977 27.7884 4.96145 27.4135 4.58652C27.0386 4.21159 26.5302 4.00066 26 4ZM6 6H10V8H12V6H20V8H22V6H26V10H6V6ZM6 12H11V18H6V12ZM19 26H13V20H19V26ZM19 18H13V12H19V18ZM21 26V20H26L26.0012 26H21Z" fill={color || theme.palette.secondary.contrastText} />
                </g>
                <g clipPath="url(#clip1_534_732)">
                    <rect x="16" width="16" height="16" rx="8" fill={bgColor || theme.palette.secondary.main} />
                    <path d="M24 15C22.6155 15 21.2622 14.5895 20.111 13.8203C18.9599 13.0511 18.0627 11.9579 17.5328 10.6788C17.003 9.3997 16.8644 7.99224 17.1345 6.63437C17.4046 5.2765 18.0713 4.02922 19.0503 3.05026C20.0292 2.07129 21.2765 1.4046 22.6344 1.13451C23.9922 0.86441 25.3997 1.00303 26.6788 1.53285C27.9579 2.06266 29.0511 2.95987 29.8203 4.11101C30.5895 5.26216 31 6.61553 31 8C31 9.85652 30.2625 11.637 28.9497 12.9497C27.637 14.2625 25.8565 15 24 15ZM24 2C22.8133 2 21.6533 2.3519 20.6666 3.01119C19.6799 3.67047 18.9108 4.60755 18.4567 5.7039C18.0026 6.80026 17.8838 8.00666 18.1153 9.17054C18.3468 10.3344 18.9182 11.4035 19.7574 12.2426C20.5965 13.0818 21.6656 13.6532 22.8295 13.8847C23.9933 14.1162 25.1997 13.9974 26.2961 13.5433C27.3925 13.0892 28.3295 12.3201 28.9888 11.3334C29.6481 10.3467 30 9.18669 30 8C30 6.4087 29.3679 4.88258 28.2426 3.75736C27.1174 2.63214 25.5913 2 24 2Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M26.295 11L23.5 8.205V3.5H24.5V7.79L27 10.295L26.295 11Z" fill={color || theme.palette.secondary.contrastText} />
                </g>
                <defs>
                    <clipPath id="clip0_534_732">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                    <clipPath id="clip1_534_732">
                        <rect x="16" width="16" height="16" rx="8" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </SvgIcon>
    );

};

export default DateTimeIcon;